var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "popup__layer active" }, [
    _c(
      "div",
      {
        staticClass: "popup__edit",
        class: { big: _vm.fieldToEdit === "picture" }
      },
      [
        _c("div", { staticClass: "popup__edit--title" }, [
          _vm._v(" " + _vm._s(_vm.$t(`profile.edit.${_vm.fieldToEdit}`)) + " ")
        ]),
        _c(
          "div",
          {
            staticClass: "popup__close",
            on: {
              click: function($event) {
                return _vm.$emit("cancel")
              }
            }
          },
          [_c("span", { staticClass: "glicon-close-large" })]
        ),
        _vm.fieldToEdit === "password"
          ? [
              _c(
                "div",
                { staticClass: "form__group" },
                [
                  _c("gl-input", {
                    directives: [
                      {
                        name: "skeletor",
                        rawName: "v-skeletor:onChange",
                        value: _vm.setValue,
                        expression: "setValue",
                        arg: "onChange"
                      }
                    ],
                    attrs: {
                      id: "profile.currentPassword",
                      type: "password",
                      label: _vm.$t("profile.edit.currentPassword"),
                      placeholder: _vm.$t("profile.edit.currentPassword"),
                      value: _vm.$v.form.currentPassword.$model,
                      errormessage: _vm.passwordError
                        ? _vm.$t(`errors.${_vm.passwordError}`)
                        : null
                    },
                    model: {
                      value: _vm.$v.form.currentPassword.$model,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.$v.form.currentPassword,
                          "$model",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "$v.form.currentPassword.$model"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form__group" },
                [
                  _c("gl-input", {
                    directives: [
                      {
                        name: "skeletor",
                        rawName: "v-skeletor:onChange",
                        value: _vm.setValue,
                        expression: "setValue",
                        arg: "onChange"
                      }
                    ],
                    attrs: {
                      id: "profile.newPassword",
                      type: "password",
                      label: _vm.$t("profile.edit.newPassword"),
                      placeholder: _vm.$t("profile.edit.newPassword"),
                      value: _vm.$v.form.newPassword.$model,
                      errormessage:
                        _vm.$v.form.newPassword.$model &&
                        _vm.$v.form.newPassword.$error
                          ? _vm.$t("errors.passwordTooShort")
                          : null
                    },
                    model: {
                      value: _vm.$v.form.newPassword.$model,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.$v.form.newPassword,
                          "$model",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "$v.form.newPassword.$model"
                    }
                  })
                ],
                1
              ),
              _c("password-strength-bar", {
                attrs: { password: _vm.$v.form.newPassword.$model }
              }),
              _c(
                "div",
                { staticClass: "form__group" },
                [
                  _c("gl-input", {
                    directives: [
                      {
                        name: "skeletor",
                        rawName: "v-skeletor:onChange",
                        value: _vm.setValue,
                        expression: "setValue",
                        arg: "onChange"
                      }
                    ],
                    attrs: {
                      id: "profile.confirmPassword",
                      type: "password",
                      label: _vm.$t("profile.edit.confirmPassword"),
                      placeholder: _vm.$t("profile.edit.confirmPassword"),
                      value: _vm.$v.form.confirmPassword.$model,
                      errormessage:
                        _vm.$v.form.confirmPassword.$model &&
                        !_vm.$v.form.confirmPassword.isSamePassword
                          ? _vm.$t("errors.passwordsDoNotMatch")
                          : null
                    },
                    model: {
                      value: _vm.$v.form.confirmPassword.$model,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.$v.form.confirmPassword,
                          "$model",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "$v.form.confirmPassword.$model"
                    }
                  }),
                  _c("div", { staticStyle: { display: "none" } }, [
                    _vm._v(_vm._s(_vm.$v.form.confirmPassword))
                  ])
                ],
                1
              )
            ]
          : _vm._e(),
        _c(
          "div",
          { staticClass: "popup__buttons" },
          [
            _c("gl-button", {
              attrs: {
                id: "profile.btn-cancel",
                "color-secondary": "",
                type: "button",
                text: _vm.$t("actions.cancel")
              },
              on: {
                onClick: function($event) {
                  $event.preventDefault()
                  return _vm.$emit("cancel")
                }
              }
            }),
            _c("gl-button", {
              attrs: {
                id: "profile.btn-update",
                "color-primary": "",
                type: "button",
                text: _vm.$t("actions.update"),
                disabled: _vm.errors || !_vm.dirtyFields
              },
              on: {
                onClick: function($event) {
                  $event.preventDefault()
                  return _vm.updateData.apply(null, arguments)
                }
              }
            })
          ],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }